(function () {
  let activeRequests = 0;
  let activeAdds = 0;

  function syncBodyClass() {
    document.documentElement.classList.toggle('cart-is-updating', activeRequests > 0);
    document.documentElement.classList.toggle('cart-is-adding', activeAdds > 0);
  }

  window.CartLock = {
    isBusy() {
      return activeRequests > 0;
    },

    isAdding() {
      return activeAdds > 0;
    },

    acquire(reason) {
      activeRequests += 1;
      const token = { adding: reason === 'add' };
      if (token.adding) activeAdds += 1;
      syncBodyClass();
      return token;
    },

    release(token) {
      activeRequests = Math.max(0, activeRequests - 1);
      if (token && token.adding) activeAdds = Math.max(0, activeAdds - 1);
      syncBodyClass();
      if (activeRequests === 0) {
        window.dispatchEvent(new CustomEvent('cart:idle'));
      }
    },
  };
})();
